<template>

<core-modal v-on:close="onClose" type="confirm">

	<template v-slot:head>

		Delete activity

	</template>

	<template v-slot:default>

		<p>Are you sure you wish to delete this activity entry?</p>

	</template>

	<template v-slot:foot>

		<core-button theme="red" v-on:click.native="onConfirmClick" :loading="is.loading">Yes</core-button>
		<core-button theme="blue" v-on:click.native="onClose">No</core-button>

	</template>

</core-modal>

</template>

<script>

export default {

	props: ['data'],

	data: function() {

		return {

			is: {
				loading: false
			}

		}

	},

	methods: {

		onConfirmClick: function() {

			this.is.loading = true

			this.$store.dispatch('api/activity/delete', {
                id: this.data.activity,
                type: this.data.type
			}).then(function() {

                this.$pubsub.$emit('activity.refresh')

				this.$emit('close')

			}.bind(this), function() {

				this.is.loading = false

			}.bind(this)) 

		},

		onClose: function() {

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

</style>